import {
    getProjects,
    getScenarios,
    projectSelected,
    projectsReceived,
    scenarioSelected,
    statusesReceived
} from "actions";
import {
    DELETE_PROJECT,
    DeleteProjectAction,
    GET_PROJECTS,
    GET_PROJECT_STATUSES,
    POST_NEW_PROJECT,
    PostNewProjectAction,
    ProjectSelectedAction,
    ProjectsReceivedAction,
    StatusesReceivedAction,
    UPDATE_PROJECT,
    UpdateProjectAction
} from "actions/Projects/types";
import axios from "axios";
import { showError } from "components/commonUtilities";
import { GeneratorYieldType } from "interfaces/ActionReducer/GetMethod/GetResponse";
import { PutEffect, put, takeEvery, takeLatest } from "redux-saga/effects";

function* getProjectsHere(): Generator<
    | Promise<ProjectsReceivedAction["payload"]["data"]>
    | GeneratorYieldType<ProjectsReceivedAction["payload"]>,
    void,
    ProjectsReceivedAction["payload"]["data"]
> {
    try {
        const json = yield axios.get("/api/project/").then((response) => response.data);
        yield put(projectsReceived({ data: json }));
    } catch (e) {
        showError(e);
    }
}
export function* getProjectsSaga() {
    yield takeLatest(GET_PROJECTS, getProjectsHere);
}

function* postNewProject(
    action: PostNewProjectAction
): Generator<
    | Promise<ProjectSelectedAction["payload"]["data"]>
    | GeneratorYieldType<ProjectSelectedAction["payload"]>
    | PutEffect<any>,
    void,
    ProjectSelectedAction["payload"]["data"]
> {
    try {
        let json = yield axios.post("/api/project/", action.payload.params).then((res) => res.data);

        yield put(getProjects());
        yield put(
            getScenarios({
                params: {
                    fields: "id,name,project_id,workorder_id,created"
                }
            })
        );
        yield put(projectSelected({ data: json }));
        let scenario = json.scenarios[0];
        if (scenario) {
            scenario = {
                ...scenario,
                label: scenario.name,
                value: scenario.id,
                listView: true,
                default: false,
                mapView: true
            };
        }
        yield put(scenarioSelected({ selectedScenario: scenario }));

        if (action.payload.afterProcess) {
            action.payload.afterProcess();
        }
    } catch (e) {
        showError(e);
    }
}

//get all the scenarios after succesful post request
export function* postNewProjectSaga() {
    yield takeLatest(POST_NEW_PROJECT, postNewProject);
}

function* GetProjectStatuses(): Generator<
    Promise<any> | GeneratorYieldType<StatusesReceivedAction["payload"]>,
    void,
    StatusesReceivedAction["payload"]["data"]
> {
    try {
        let json = yield axios.get("/api/project-status/").then((res) => res.data);
        yield put(statusesReceived({ data: json }));
    } catch (e) {
        showError(e);
    }
}

export function* getProjectStatusesSaga() {
    yield takeLatest(GET_PROJECT_STATUSES, GetProjectStatuses);
}

function* DeleteProject(action: DeleteProjectAction) {
    try {
        yield axios.delete(`/api/project/${action.payload.project_id}/`);
        if (action.payload.afterProcess) {
            action.payload.afterProcess();
        }
        yield put(getProjects());
    } catch (error) {
        showError(error);
    }
}

export function* DeleteProjectSaga() {
    yield takeEvery(DELETE_PROJECT, DeleteProject);
}

function* UpdateProject(action: UpdateProjectAction) {
    try {
        yield axios.patch(`/api/project/${action.payload.project_id}/`, action.payload.params);
        if (action.payload.afterProcess) {
            action.payload.afterProcess();
        }
        yield put(getProjects());
    } catch (e) {
        showError(e);
    }
}

export function* UpdateProjectSaga() {
    yield takeEvery(UPDATE_PROJECT, UpdateProject);
}
